(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-fs-card]').forEach(card => {
      if (card.dataset.bound) return;
      card.dataset.bound = 'true';
      const select = card.querySelector('select[name="id"]');
      const price = card.querySelector('[data-fs-price]');
      const button = card.querySelector('button[type="submit"]');
      const links = card.querySelectorAll('[data-fs-product-link]');
      if (!select) return;
      const update = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        price.textContent = option.dataset.price;
        button.disabled = option.disabled;
        button.textContent = option.disabled ? 'Sold out' : 'Add to cart';
        links.forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', select.value);
          link.href = url.toString();
        });
      };
      select.addEventListener('change', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();